// Format only marked US cart measurements. Native option values remain unchanged.
(() => {
  if (customElements.get('clc-inch-label')) return;
  const common = {'¼':'1/4','½':'1/2','¾':'3/4','⅓':'1/3','⅔':'2/3','⅕':'1/5','⅖':'2/5','⅗':'3/5','⅘':'4/5','⅙':'1/6','⅚':'5/6','⅛':'1/8','⅜':'3/8','⅝':'5/8','⅞':'7/8'};
  const digits = (value, alphabet) => [...value].map(digit => alphabet.indexOf(digit)).join('');
  customElements.define('clc-inch-label', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.formatted) return;
      const original = this.textContent;
      const matches = [...original.matchAll(/([⁰¹²³⁴⁵⁶⁷⁸⁹]+)⁄([₀₁₂₃₄₅₆₇₈₉]+)|(\d+)\/(\d+)|([¼½¾⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞])/g)];
      if (!matches.length) return;
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      const appendText = value => value.replaceAll('≈', '').split(/[-–—]/).forEach((part, index) => {
        if (index) {
          const separator = document.createElement('span');
          separator.className = 'clc-inch-range-separator';
          separator.textContent = ' – ';
          visible.append(separator);
        }
        visible.append(document.createTextNode(part));
      });
      let offset = 0;
      matches.forEach(match => {
        const prefix = original.slice(offset, match.index);
        appendText(prefix);
        if (/\d$/.test(prefix)) visible.append(document.createTextNode('\u00a0'));
        const fraction = document.createElement('span');
        fraction.className = 'clc-cart-inch-fraction';
        fraction.textContent = match[5] ? common[match[5]] : match[1]
          ? `${digits(match[1], '⁰¹²³⁴⁵⁶⁷⁸⁹')}/${digits(match[2], '₀₁₂₃₄₅₆₇₈₉')}`
          : `${match[3]}/${match[4]}`;
        visible.append(fraction);
        offset = match.index + match[0].length;
      });
      appendText(original.slice(offset));
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      accessible.textContent = original;
      this.replaceChildren(visible, accessible);
      this.dataset.formatted = 'true';
    }
  });
})();

